<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Minus } from 'lucide-vue-next';

    withDefaults(
        defineProps<{
            buttonText?: string;
        }>(),
        {
            buttonText: 'tables.create',
        },
    );
</script>

<template>
    <Button
        variant="ghost_destructive"
        width="narrow"
        class="self-start"
        size="xs"
    >
        <span>{{ $t(buttonText) }}</span>
        <Minus class="text-destructive" />
    </Button>
</template>
